import React from "react";
//components
import Modal from "../../../components/modal/Modal";

const ModalSigners = ({ visible, setVisible, signers }) => {
    const getStatusIcon = (status) => {
        if (status === "pending") {
          return <i className="fa-regular fa-clock text-warning"></i>;
        } else {
          return <i className="fa fa-check text-success"></i>;
        }
      };
    
  return (
    <>
      <Modal
        visible={visible}
        dynamicTitle={"Assinantes"}
        dynamicWidth={window.innerWidth <= 992 ? "85vw" : "25vw"}
        onHide={() => setVisible(false)}
        closable={true}
      >
        <div className="">
          <h4 className="mb-4">O E-mail de assinatura foi enviado para:</h4>
          {signers?.map((s, index) => (
            <div key={index} className="d-flex align-items-center justify-content-start my-1">
              {" "}
              <div>{getStatusIcon(s.status)}</div>
              <h5 className="mx-2">{s.email_signer}</h5>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default ModalSigners;
